import { getDecimalSeparator, getGroupSeparator } from "@smartsuite/fields-logic/lib/utils/number";
import { maxWholeDigits } from "@smartsuite/types";
import type { AppFieldParams } from "../../../../types/form";

export const isAllowedValue = (
  formattedValue: string,
  fieldParameters: { max_length?: number },
): boolean => {
  if (!formattedValue) return true;

  // Get only the digits from the formatted value (excluding decimal separator and negative sign)
  const digitsOnly = formattedValue.replaceAll(/\D/g, "");

  // Calculate max allowed digits (default to maxWholeDigits if not specified)
  const maxDigits = fieldParameters.max_length ?? maxWholeDigits;

  return digitsOnly.length <= maxDigits;
};

export const getSeparators = (
  fieldParams: AppFieldParams,
): {
  decimal_separator?: string;
  thousand_separator?: string;
} => {
  return {
    decimal_separator: fieldParams.decimal_separator ?? getDecimalSeparator(navigator.language),
    thousand_separator: fieldParams.separator
      ? (fieldParams.thousand_separator ?? getGroupSeparator(navigator.language))
      : undefined,
  };
};
